import { AfterViewInit, Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[runScript]',
})
export class RunScriptDirective implements OnInit {
  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    setTimeout(() => {
      // wait for DOM rendering
      this.reinsertScripts();
    });
  }
  reinsertScripts(): void {
    const scripts = <HTMLScriptElement[]>(
      this.elementRef.nativeElement.getElementsByTagName('script')
    );
    const scriptsInitialLength = scripts.length;

    for (let i = 0; i < scriptsInitialLength; i++) {
      const script = scripts[i];
      this.replaceScript(script);
      //   const infographicId= script.id.split('/')[1];
      //   const existingIframes=document.getElementsByTagName('iframe');
      //   if(existingIframes && existingIframes.length > 0) {
      //     let existingIframeForInfographic=null;

      //     for (let j = 0; j < existingIframes.length;j++){
      //         const iframe=existingIframes[j];
      //         if(iframe.getAttribute('src').includes(infographicId)){
      //             existingIframeForInfographic=iframe;
      //             console.log('existingIframeForInfographic found'+existingIframeForInfographic);
      //             break;
      //         }

      //     }
      //     if(existingIframeForInfographic){
      //         script.parentNode.insertBefore(existingIframeForInfographic, script.nextSibling);
      //     }else{
      //         this.replaceScript(script);
      //     }

      //   }else{
      //     this.replaceScript(script);
      //   }
    }
  }

  replaceScript(script) {
    const scriptCopy = <HTMLScriptElement>document.createElement('script');
    scriptCopy.type = script.type ? script.type : 'text/javascript';
    scriptCopy.id = script.id;
    scriptCopy.title = script.title;
    // console.log(script);
    if (script.innerHTML) {
      scriptCopy.innerHTML = script.innerHTML;
    } else if (script.src) {
      scriptCopy.src = script.src;
    }
    scriptCopy.async = false;
    script.parentNode.replaceChild(scriptCopy, script);
  }
}
